import { Controller } from "@hotwired/stimulus"

// Due date = invoice date + payment terms (days). Server keeps whatever is submitted.
export default class extends Controller {
  static targets = ["issue", "terms", "due"]

  update() {
    const issue = this.issueTarget.value
    if (!issue) return
    const due = new Date(`${issue}T00:00:00`)
    due.setDate(due.getDate() + Number(this.termsTarget.value || 0))
    const iso = `${due.getFullYear()}-${String(due.getMonth() + 1).padStart(2, "0")}-${String(due.getDate()).padStart(2, "0")}`
    const picker = this.dueTarget._flatpickr
    picker ? picker.setDate(iso, false) : (this.dueTarget.value = iso)
  }
}
